import { formatMode } from 'spot-quote/presenter/spotQuotePresenter'
import styled from 'styled-components/macro'

import { Layout } from '@loadsmart/loadsmart-ui'
import { getToken } from '@loadsmart/loadsmart-ui/dist/theming'

import { featureFlag } from 'core/config/feature-flags/constants.featureFlags'
import { RenderFeature } from 'core/config/feature-flags/RenderFeature'

import { type Quote } from '../domain/Quote'
import { QuoteAccessorials } from './QuoteAccessorials'
import { QuoteItem } from './QuoteItem'

const StyledStack = styled(Layout.Stack)`
  padding-bottom: ${getToken('space-l')};
`

export type QuoteDetailsProps = {
  quote: Quote
}

export function QuoteDetails({ quote }: QuoteDetailsProps) {
  const [item] = quote.items
  const showAccessorials = quote.mode === 'full_truck_load' || quote.mode === 'less_than_truckload'

  return (
    <StyledStack space="m">
      <QuoteItem label="Mode" value={formatMode(quote)} />
      <QuoteItem label="Equipment Type" value={quote.equipmentType} />
      {item && (
        <>
          {item.commodity && <QuoteItem label="Commmodity" value={item.commodity} />}
          {item.weight && <QuoteItem label="Weight" value={item.weight} />}
        </>
      )}
      {showAccessorials && (
        <RenderFeature flag={featureFlag.quoteAccessorials}>
          <QuoteAccessorials accessorials={quote.accessorials} />
        </RenderFeature>
      )}
      {quote.shipperNotes && <QuoteItem label="Shipper Notes" value={quote.shipperNotes} />}
    </StyledStack>
  )
}
